// Unpublished Work © 2023 Deere & Company.

import {
    datadogRum,
    type RumEvent,
    type RumInitConfiguration,
} from '@datadog/browser-rum';
import {datadogLogger} from '@deere/datadog-action-logger';

const ddEnvironments = ['qual', 'cert', 'prod'];
const SESSION_TRANSPORT_ERROR = 'SessionTransportError';

function filterRumEvents(event: RumEvent) {
    if (event.type !== 'error') {
        return true;
    }

    return (
        event.error.type !== SESSION_TRANSPORT_ERROR &&
        !/ResizeObserver/.test(event.error.message)
    );
}

export function initRum(env: string) {
    if (!ddEnvironments.includes(env)) {
        return;
    }

    const options: RumInitConfiguration = {
        applicationId: 'd3598ce8-a295-4ac8-b825-4c0f707df800',
        clientToken: 'pub7763977dd73328a48c77ebfa3ddf53fc',
        site: 'datadoghq.com',
        service: 'work-planner',
        env,
        version: `git:${process.env.GITHUB_SHA}:${env}`, // TODO: migration-vite before: import.meta.env.GITHUB_SHA
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [
            /^https:\/\/[a-zA-Z0-9.-]*\.deere\.com\//,
            /^https:\/\/[a-zA-Z0-9.-]*\.johndeerecloud\.com\//,
        ],
        beforeSend: filterRumEvents,
    };

    datadogRum.setGlobalContextProperty('jd_component', 'work-planner-client');

    datadogRum.init(options);

    datadogLogger.setRumInstance(datadogRum);
}

export function setUser(userId: string) {
    datadogRum.setUser({
        id: userId,
    });
}
